export function formatDate(date, format = "yyyy-MM-dd") {
  const yyyy = date.getFullYear();

  let mm = date.getMonth() + 1;
  mm = mm < 10 ? "0" + mm : mm;

  let dd = date.getDate();
  dd = dd < 10 ? "0" + dd : dd;

  let hh = date.getHours();
  hh = hh < 10 ? "0" + hh : hh;

  let minu = date.getMinutes();
  minu = minu < 10 ? "0" + minu : minu;

  let ss = date.getSeconds();
  ss = ss < 10 ? "0" + ss : ss;

  return format
    .replace("yyyy", yyyy)
    .replace("MM", mm)
    .replace("dd", dd)
    .replace("hh", hh)
    .replace("mm", minu)
    .replace("ss", ss);
}

export function delEmpty(obj) {
  return Object.keys(obj)
    .filter(i => obj[i] !== "" && obj[i] !== null)
    .reduce((total, i) => {
      total[i] = obj[i];
      return total;
    }, {});
}

export function downloadWithBlob(url, name) {
  fetch(url).then(res =>
    res.blob().then(blob => {
      var a = document.createElement("a");
      var url = window.URL.createObjectURL(blob);
      var filename = name;
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    })
  );
}
export function downloadFileByBlob(blobUrl, filename) {
  var reader = new FileReader();
  reader.readAsDataURL(blobUrl);
  reader.onload = function (e) {
    var a = document.createElement("a");
    // 获取文件名fileName
    a.download = filename;
    a.href = e.target.result;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
}

function judgePid(i, pid, judge) {
  if (judge) {
    return i.pid === pid;
  } else {
    return i.pid !== pid;
  }
}

export function getTreeData(arr, pid) {
  pid = pid || "";
  let target = [];
  target = arr.filter(i => judgePid(i, pid, true));
  let filterArr = arr.filter(i => judgePid(i, pid, false));
  target = target.map(i => {
    i.children = getTreeData(filterArr, i.id);
    return i;
  });
  return target;
}
